<template>
  <div class="toolbar__active-filters" v-show="filters.length">
    <ul>
      <li class="_title">{{ $t('Active filters') }}:</li>
      <template v-for="filter in filters">
        <li v-for="option in filter.options.filter(o => o.active)" :key="option.label">
          <label @click="$store.dispatch(`${dataSource}/toggleFilter`, { filter: filter, option: option })">{{ option.label }}</label>
        </li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'product-list-active-filter-list'
  })

  export default class extends Vue {
    @Prop({required: true}) dataSource: string;

    private get filters(): Array<object> {
      return this.$store.getters[`${this.dataSource}/activeFilters`];
    }
  }
</script>
